import React from 'react';

import PageTitleNew from 'components/ui/PageTitleNew';

import Form from 'components/Admin/Avatars/Widget/Form';

import { useNavigate } from 'react-router-dom';

import actions from 'components/Admin/Avatars/Actions/Actions';

export default function Index() {
  const navigate = useNavigate();

  const onSave = (values, onSuccess, onError) => {
    actions.create(values, () => {
      onSuccess();
      navigate('/admin/avatars');
    }, onError);
  };

  const onClose = () => {
    navigate('/admin/avatars');
  };

  return (
    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="Create New AI Coach" />

      <Form
        onSave={onSave}
        onClose={onClose}
        avatar={{
          name: '',
          greeting: '',
          description: '',
          is_public: false,
          heygen: '',
          bedrock_agent: '',
          bedrock_alias: '',
          prompt_ids: [],
        }}
      />
    </div>
  );
}
